/** Explicitly opt in when a bespoke product has no confirmed delivery estimate. */
export function pendingDeliveryPresentation(providerType: string | undefined, specifications: Record<string, unknown> | null | undefined, locale: string) {
  if (providerType !== 'CUSTOM' || specifications?.deliveryEstimatePending !== true) return null;
  const copy = {
    nl: { label: 'Na bestandscontrole', businessDays: 'Levertermijn wordt bevestigd na bestandscontrole' },
    en: { label: 'After artwork review', businessDays: 'Delivery time confirmed after artwork review' },
    de: { label: 'Nach Dateiprüfung', businessDays: 'Lieferzeit wird nach Dateiprüfung bestätigt' },
    fr: { label: 'Après contrôle du fichier', businessDays: 'Délai confirmé après contrôle du fichier' },
  };
  const language = locale.split('-')[0].toLowerCase() as keyof typeof copy;
  return { ...(copy[language] || copy.en), estimatedDate: '' };
}
